import solicitudes from './solicitudes.js';

// Helper: obtiene el id_sucursal del override si Admin/CEO está en caja
function getCajaSucursalParam() {
    try {
        const role = localStorage.getItem('role');
        if (role !== '1' && role !== '4') return '';
        const override = JSON.parse(localStorage.getItem('caja_sucursal_override') || 'null');
        return override?.id_sucursal ? `?id_sucursal=${override.id_sucursal}` : '';
    } catch { return ''; }
}

export const getInfoBasic = async (id_usuario) => {
    try {
        const infoBasic = await solicitudes.fetchRegistrosAuth(`/ventas/${id_usuario}${getCajaSucursalParam()}`);

        return infoBasic;
    } catch (error) {
        console.error('Error al obtener la unidad de medida:', error);

        throw new Error('No se pudo obtener la informacion para el usuario especificado.');

    }
}

export const getProductos = async (id_usuario) => {
    try {
        const productos = await solicitudes.fetchRegistrosAuth(`/ventas/detalles/${id_usuario}${getCajaSucursalParam()}`);

        return productos;
    } catch (error) {
        console.error('Error al obtener los productos:', error);

        throw new Error('No se pudo obtener los productos el usuario especificado.');

    }
}

export const getVentaPendiente = async (id_usuario) => {
    try {
        const productos = await solicitudes.fetchRegistrosAuth(`/ventas/venta-pendiente/${id_usuario}${getCajaSucursalParam()}`);

        return productos;
    } catch (error) {
        console.error('Error al obtener los productos:', error);

        throw new Error('No se pudo obtener los productos el usuario especificado.');
    
    }
}

export const getRecProductoVenta = async (id_compra) => {
    try {
        const productos = await solicitudes.fetchRegistrosAuth(`/ventas/rec-venta/${id_compra}`);

        return productos;
    } catch (error) {
        console.error('Error al obtener los productos:', error);

        throw new Error('No se pudo obtener los productos el usuario especificado.');
    
    }
}

export const getVentasGuardadas = async (id_usuario) => {
    try {
        const ventas = await solicitudes.fetchRegistrosAuth(`/ventas/mostrar-ventas/${id_usuario}`);

        return ventas;
    } catch (error) {
        console.error('Error al obtener los productos:', error);

        throw new Error('No se pudo obtener los productos el usuario especificado.');
    
    }
}

export const cajaUsuario = async (id_usuario) => {
    try {
        const data = await solicitudes.fetchRegistrosAuth(`/ventas/existencia-caja/${id_usuario}`);
        // El backend devuelve { resultado: false } si no hay caja abierta para este usuario
        if (data?.resultado === false) return false;
        return true;
    } catch {
        return false;
    }
}

export const createCaja = async (id_usuario, valor_inicial) => {

    const datos = {
        id_usuario: id_usuario,
        valor_inicial: valor_inicial
    }

    const parametros = `/ventas/crear-caja`;
    try {

        const response = await solicitudes.postRegistroAuth(parametros, datos);
        console.log(response);

            return response;

    } catch (error) {
        console.error('Error al crear caja:', error);
        throw error;
    }
}

export const cerrarCaja = async(id_usuario, dineroCaja) => {
    const datos = { dineroCaja: dineroCaja };
    const parametros = `/ventas/cerrar-caja/${id_usuario}`;
    try {
        const response = await solicitudes.patchRegistroProductoAuth(parametros, datos);
        return response;
    } catch (error) {
        console.error('Error al cerrar caja:', error);
        throw error;
    }
}

export const agregarProductoCodigo = async (cantidad, codigo, id_usuario) => {

    const datos = {
        codigo: codigo,
        cantidad: cantidad
    }

    const parametros = `/ventas/buscar-producto/${id_usuario}`;
    try {

        const response = await solicitudes.agregarProductoListaAuth(parametros, datos);

            return response; 

    } catch (error) {
        console.error('Error en patchProducto:', error); 
        throw error;
    }
}

export const eliminarProductoVenta = async (id_producto, passwordTry, id_usuario) => {

    const datos = {
        id_producto:id_producto,
        passwordTry: passwordTry
    }

    const parametros = `/ventas/eliminar-producto/${id_usuario}`;
    try {

        const response = await solicitudes.patchRegistroProductoAuth(parametros, datos);
        console.log(response);

            return response; 

    } catch (error) {
        console.error('Error en patchProducto:', error); 
        throw error;
    }
}

export const borrarProductoVenta = async (id_usuario, id_producto) => {

    const datos = {
        id_producto: id_producto
    }

    const parametros = `/ventas/eliminar-producto/${id_usuario}`;
    try {

        const response = await solicitudes.patchRegistroProductoAuth(parametros, datos);

            return response;

    } catch (error) {
        console.error('Error en patchProducto:', error); 
        throw error;
    }
}

export const guardarVenta = async (nombre_completo, id_usuario) => {
    const parametros = `/ventas/guardar-venta/${id_usuario}`;

    const datos = {
        nombre_completo: nombre_completo
    }

    try {
        const response = await solicitudes.postRegistroAuth(parametros, datos);

        return response;

    } catch (error) {
        console.error('Error en guardar Venta:', error);
        throw error;
    }
}

export const postVenta = async (productos, id_cliente, id_usuario) => {
    const parametros = `/ventas/confirmar/${id_usuario}`;

    const datos = {
        productos: productos
    }

    if(id_cliente !== 0 && id_cliente !== null){
        datos.id_cliente = id_cliente;
    }

    // Si Admin/CEO está vendiendo en una sucursal específica, incluirla en el body
    try {
        const role = localStorage.getItem('role');
        if (role === '1' || role === '4') {
            const override = JSON.parse(localStorage.getItem('caja_sucursal_override') || 'null');
            if (override?.id_sucursal) datos.id_sucursal = override.id_sucursal;
        }
    } catch { /* */ }
    try {

        const response = await solicitudes.postRegistroAuth(parametros, datos);


        return response;

    } catch (error) {
        console.error('Error en postUnidad:', error); // Registra el error para depuración
        throw error; // Opcional: vuelve a lanzar el error para manejarlo en otro lugar
    }
}

export const eliminarVenta = async (id_venta, id_factura) => {

    const parametros = `/ventas/eliminar-venta/${id_venta}/${id_factura}`;
    try {
        const response = await solicitudes.deleteRegistroAuth(parametros);
        if(response){
            return {
                message: 'Se elimino la venta',
                resultado: true
            };
        }

        throw response;
    } catch (error) {
        return {
            message: error,
            resultado: false
        }
    }
}

export const pagar = async (pago, id_venta, descripcion, id_usuario, ids_devolucion = null) => {

    const datos = {
        id_venta: id_venta,
        pago: pago,
        id_usuario: id_usuario,
        descripcion: descripcion,
        ...(ids_devolucion?.length ? { ids_devolucion } : {})
    }

    const parametros = `/ventas/pagar-efectivo`;
    try {

        const response = await solicitudes.patchRegistroAuth(parametros, datos);

        if (response && response == true) {

            return response; // Retorna el registro creado o la respuesta completa
        } else {
            throw new Error('No se hizo el patch');
        }

    } catch (error) {
        console.error('Error al registrar pago de venta:', error); // Registra el error para depuración
        throw error; // Opcional: vuelve a lanzar el error para manejarlo en otro lugar
    }
}

export const pagarTranferir = async (pago, id_venta, numeroTransferencia, notas, id_usuario, ids_devolucion = null) => {

    const datos = {
        id_venta: id_venta,
        pago: pago,
        id_usuario: id_usuario,
        descripcion: `Numero de transferencia: ${numeroTransferencia}. Notas: ${notas}`,
        ...(ids_devolucion?.length ? { ids_devolucion } : {})
    }

    const parametros = `/ventas/pagar-transferencia`;
    try {

        const response = await solicitudes.patchRegistroAuth(parametros, datos);

        if (response && response == true) {

            return response; // Retorna el registro creado o la respuesta completa
        } else {
            console.log(response);
            throw new Error('No se hizo el patch');
        }

    } catch (error) {
        console.error('Error al registrar pago de venta:', error); // Registra el error para depuración
        throw error; // Opcional: vuelve a lanzar el error para manejarlo en otro lugar
    }
}

// NUEVA FUNCIÓN PARA PAGO MIXTO
export const pagarMixto = async (montoEfectivo, montoTransferencia, numeroTransferencia, id_venta, notas, id_usuario, ids_devolucion = null) => {

    const datos = {
        id_venta: id_venta,
        montoEfectivo: montoEfectivo,
        montoTransferencia: montoTransferencia,
        numeroTransferencia: numeroTransferencia,
        id_usuario: id_usuario,
        descripcion: notas || "Pago mixto",
        ...(ids_devolucion?.length ? { ids_devolucion } : {})
    }

    const parametros = `/ventas/pagar-mixto`;
    try {

        const response = await solicitudes.patchRegistroAuth(parametros, datos);

        if (response && response == true) {

            return response; // Retorna el registro creado o la respuesta completa
        } else {
            console.log(response);
            throw new Error('No se hizo el patch');
        }

    } catch (error) {
        console.error('Error al registrar pago mixto:', error); // Registra el error para depuración
        throw error; // Opcional: vuelve a lanzar el error para manejarlo en otro lugar
    }
}

export const validarTerceraEdad = async (fechaNacimiento, numeroIdentidad, id_usuario) => {
    try {
        // Validar parámetros
        if (!fechaNacimiento || !numeroIdentidad) {
            throw new Error('Fecha de nacimiento y número de identidad son requeridos');
        }

        // Crear el objeto con los datos a enviar
        const datos = {
            fecha_nacimiento: fechaNacimiento,
            numero_identidad: numeroIdentidad
        };

        // Hacer la petición al backend
        const response = await solicitudes.postRegistroAuth(`/ventas/validar-tercera-edad/${id_usuario}`, datos);
        
        return response;

    } catch (error) {
        console.error('Error al validar tercera edad:', error);
        throw new Error('No se pudo validar la tercera edad del cliente');
    }
};

// En ventasSolicitudes.js - agregar esta nueva función
export const registrarVentaCredito = async (id_venta, id_cliente, notas, id_usuario, ids_devolucion = null, monto_adelanto = 0) => {
    const datos = {
        id_venta: id_venta,
        id_cliente: id_cliente,
        descripcion: notas || "Venta a crédito",
        id_usuario: id_usuario,
        monto_adelanto: Number(monto_adelanto) || 0,
        ...(ids_devolucion?.length ? { ids_devolucion } : {})
    };

    const parametros = `/ventas/credito`;
    try {
        const response = await solicitudes.patchRegistroAuth(parametros, datos);

        if (response && response == true) {
            return response;
        } else {
            console.log(response);
            throw new Error('No se pudo registrar la venta a crédito');
        }

    } catch (error) {
        console.error('Error al registrar venta a crédito:', error);
        throw error;
    }
}